module.exports = __webpack_public_path__ + "static/45-d4151b6d2cdfbd6a588d410974994946.png";